
import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
    const { i18n } = useTranslation();

    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
    };

    return (
        <div className="flex space-x-2">
            <button
                onClick={() => changeLanguage('en')}
                className={`px-2 py-1 rounded \${i18n.language.startsWith('en') ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-800'}`}
            >
                EN
            </button>
            <button
                onClick={() => changeLanguage('fr')}
                className={`px-2 py-1 rounded \${i18n.language.startsWith('fr') ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-800'}`}
            >
                FR
            </button>
            <button
                onClick={() => changeLanguage('ar')}
                className={`px-2 py-1 rounded \${i18n.language.startsWith('ar') ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-800'}`}
                dir="rtl"
            >
                عربي
            </button>
        </div>
    );
};

export default LanguageSwitcher;
